import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

export interface DvsInstructorDetail {
  instructorId: number;
  instructorName: string;
  userId: number;
  userName: string;
  contactNumber: string;
  emailAddress: string;
  schoolName: string;
  allocated: number;
  evaluated: number;
  pending: number;
  inProgress: number;
  autoFillAssign: number;
}

export interface DvsAllocationDetail {
  autoAssignmentPaper: boolean;
  details: DvsInstructorDetail[];
  totalStudents: number[];
  remainingStudentCount: number[];
}

export interface DvsUploadedPaper {
  id: string;
  studentName: string;
  studentCode: string;
  url: string | null;
  issueReported: boolean;
  issueReportedRemarks: string;
  evaluatorName: string;
  evaluationStatus: string;
}

export interface DvsAssignInstructorInput {
  instructorId: number;
  instructorName: string;
  papersToAssign: number;
}

class DvsPaperAllocationService {
  private baseUrl = `${Config.nodeSiteUrl}v1/dvs-paper-allocation`;

  /** Manage Digital Paper — allocation detail. */
  async getDetail(testId: number): Promise<DvsAllocationDetail> {
    const res: any = await myAxios.get(`${this.baseUrl}/tests/${testId}/detail`);
    return res.data.data;
  }

  /** Assign unassigned papers to instructors. Returns the HTML summary table. */
  async assign(testId: number, instructorData: DvsAssignInstructorInput[]): Promise<{ status: number; data: string }> {
    const res: any = await myAxios.post(`${this.baseUrl}/assign`, { testId, instructorData });
    return res.data;
  }

  /** Reclaim N papers from an instructor. */
  async reclaim(params: {
    testId: number;
    instructorId: number;
    reclaimPapers: number;
    includeInProgress: boolean;
  }): Promise<{ status: number; data: string }> {
    const res: any = await myAxios.post(`${this.baseUrl}/reclaim`, params);
    return res.data;
  }

  /** Uploaded Scanned Paper — listing. */
  async getUploadedPapers(testId: number): Promise<DvsUploadedPaper[]> {
    const res: any = await myAxios.get(`${this.baseUrl}/tests/${testId}/uploaded`);
    return res.data.data;
  }

  /** Re-open an evaluated paper. */
  async reopen(params: { id: string; studentcode: string; studentname: string }): Promise<{ status: number; message: string }> {
    const res: any = await myAxios.post(`${this.baseUrl}/reopen`, params);
    return res.data;
  }

  /** Send Alert For Not Submitted (students). */
  async alertNotSubmitted(params: {
    testId: number; sendSms: boolean; sendEmail: boolean; sendWhatsApp: boolean;
  }): Promise<{ status: number; message: string }> {
    const res: any = await myAxios.post(`${this.baseUrl}/alert/not-submitted`, params);
    return res.data;
  }

  /** Send Alert For Not Evaluated (evaluators). */
  async alertNotEvaluated(params: {
    testId: number; sendSms: boolean; sendEmail: boolean; sendWhatsApp: boolean;
  }): Promise<{ status: number; message: string }> {
    const res: any = await myAxios.post(`${this.baseUrl}/alert/not-evaluated`, params);
    return res.data;
  }

  /** Upload Scanned Test Paper — multipart zip of <StudentCode>.pdf files. */
  async uploadZip(testId: number, file: File, studentCount: number): Promise<any> {
    const formData = new FormData();
    formData.append("uploadedFile", file);
    formData.append("studentCount", String(studentCount));
    const res: any = await myAxios.post(`${this.baseUrl}/tests/${testId}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  }
}

export default new DvsPaperAllocationService();
